<template>
  <div class="gl-skeleton-amount__wrapper">
    <div
      v-if="type == 'amount'"
      class="gl-skeleton-amount__amount"
    >
      <div class="gl-skeleton-amount__value" />
      <div>
        {{ coinData.key }}
      </div>
    </div>
    <div
      v-if="type == 'price'"
      class="gl-skeleton-amount__price"
    >
      <div class="gl-skeleton-amount__value" />
      <div>
        {{ userData.preferredCurrency }}
      </div>
    </div>
    <div
      v-if="type == 'percent'"
      class="gl-skeleton-amount__percent"
    >
      <div class="gl-skeleton-amount__value" />
      <div> % </div>
    </div>
  </div>
</template>

<script>
// Vuex
import { mapState } from 'vuex'

export default {
  name: 'GlSkeletonAmount',
  props: {
    type: {
      type: String,
      default: 'amount',
    },
  },
  computed: {
    ...mapState('analytics', ['coinData']),
    ...mapState('user', ['userData']),
  },
}
</script>

<style scoped>
.gl-skeleton-amount__amount,
.gl-skeleton-amount__price,
.gl-skeleton-amount__percent {
  display: flex;
  gap: 4px;
  align-items: center;
  text-transform: uppercase;
}
.gl-skeleton-amount__amount {
  color: var(--Basic-900, #091540);
  font-size: var(--Size-L, 16px);
}
.gl-skeleton-amount__price {
  color: var(--Basic-800, rgba(9, 21, 64, 0.68));
  font-size: var(--Size-S, 12px);
}
.gl-skeleton-amount__amount .gl-skeleton-amount__value {
  width: 96px;
  height: 16px;
  border-radius: 16px;
  background: var(--Basic-200, rgba(9, 21, 64, 0.08));
  color: transparent;
}
.gl-skeleton-amount__price .gl-skeleton-amount__value {
  width: 60px;
  height: 12px;
  border-radius: 16px;
  background: var(--Basic-200, rgba(9, 21, 64, 0.08));
  color: transparent;
}
.gl-skeleton-amount__percent .gl-skeleton-amount__value {
  width: 32px;
  height: 16px;
  border-radius: 16px;
  background: var(--Basic-200, rgba(9, 21, 64, 0.08));
  color: transparent;
}
</style>
